import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment.prod';

Sentry.init({
  dsn: 'https://c13f4ea837d0c26bcee8c03328316602@o442018.ingest.us.sentry.io/4510657962115072',
  environment: environment.SENTRY_ENVIRONMENT,
  tracesSampleRate: 1.0,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
  ],
  enableLogs: true,
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/app-api.kingiftcard.com\/api\/v1/,
    /^https:\/\/apiaccount.rhinobit.net\/api\/v1/,
  ],
});

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
